export const hostingTariffs = [
  {
    id: 0,
    name: 'Start-1',
    type: 'hdd',
    properties: {
      disk: 1,
      domains: 10,
      sites: 1,
      db: 1,
      mail: 'none',
      limit: 96,
      php: '5.2-8.0'
    },
    price: 53,
    priceList: [
      { period: 1, val:  53},
      { period: 3, val:  159},
      { period: 6, val:  318},
      { period: 12, val:  600},
      { period: 24, val:  1152}
    ]
  },
  {
    id: 1,
    name: 'Start-2',
    type: 'hdd',
    properties: {
      disk: 5,
      domains: 20,
      sites: 2,
      db: 2,
      mail: 10,
      limit: 128,
      php: '5.2-8.0'
    },
    price: 99,
    priceList: [
      { period: 1, val:  99},
      { period: 3, val:  297},
      { period: 6, val:  594},
      { period: 12, val:  1128},
      { period: 24, val:  2136}
    ]
  },
  {
    id: 2,
    name: 'Start-3',
    type: 'hdd',
    properties: {
      disk: 10,
      domains: 50,
      sites: 5,
      db: '∞',
      mail: '∞',
      limit: 128,
      php: '5.2-8.0'
    },
    price: 176,
    priceList: [
      { period: 1, val: 176},
      { period: 3, val: 528},
      { period: 6, val: 1056},
      { period: 12, val: 2004},
      { period: 24, val:  3792}
    ]
  },
  {
    id: 3,
    name: 'Start-4',
    type: 'hdd',
    properties: {
      disk: 30,
      domains: '∞',
      sites: '∞',
      db: '∞',
      mail: '∞',
      limit: 128,
      php: '5.2-8.0'
    },
    price: 319,
    priceList: [
      { period: 1, val: 319},
      { period: 3, val: 957},
      { period: 6, val: 1914},
      { period: 12, val: 3636},
      { period: 24, val: 6888}
    ]
  },
  {
    id: 4,
    name: 'SSD-1',
    type: 'ssd',
    properties: {
      disk: 2,
      domains: 10,
      sites: 1,
      db: 1,
      mail: 5,
      limit: 256,
      php: '5.2-8.0'
    },
    price: 68,
    priceList: [
      { period: 1, val: 68},
      { period: 3, val: 204},
      { period: 6, val: 408},
      { period: 12, val: 780},
      { period: 24, val: 1464}
    ]
  },
  {
    id: 5,
    name: 'SSD-2',
    type: 'ssd',
    properties: {
      disk: 5,
      domains: 20,
      sites: 2,
      db: 2,
      mail: 10,
      limit: 256,
      php: '5.2-8.0'
    },
    price: 143,
    priceList: [
      { period: 1, val: 143},
      { period: 3, val: 429},
      { period: 6, val: 858},
      { period: 12, val: 1632},
      { period: 24, val: 3096}
    ]
  },
  {
    id: 6,
    name: 'SSD-3',
    type: 'ssd',
    properties: {
      disk: 10,
      domains: 50,
      sites: 5,
      db: '∞',
      mail: '∞',
      limit: 256,
      php: '5.2-8.0'
    },
    price: 198,
    priceList: [
      { period: 1, val: 198},
      { period: 3, val: 594},
      { period: 6, val: 1188},
      { period: 12, val: 2256},
      { period: 24, val: 4272}
    ]
  },
  {
    id: 7,
    name: 'SSD-4',
    type: 'ssd',
    properties: {
      disk: 30,
      domains: '∞',
      sites: '∞',
      db: '∞',
      mail: '∞',
      limit: 256,
      php: '5.2-8.0'
    },
    price: 352,
    priceList: [
      { period: 1, val: 352},
      { period: 3, val: 1056},
      { period: 6, val: 2112},
      { period: 12, val: 4008},
      { period: 24, val: 7608}
    ]
  }
]
